import * as React from 'react';
import { memo } from 'react';
import { INTEGRATIONS } from '../../../../../routes';
import Breadcrumbs from '../../../../components/Breadcrumbs';

type Props = {
    page: string;
    path?: {
        label: string;
        url: string;
    }[];
};

const makeBreadrumbPath = ({ path = [], page }: Props) => {
    return [
        {
            label: 'Integrations',
            url: INTEGRATIONS,
            prependBaseUrl: true,
        },
        ...path.map(p => ({ ...p, prependBaseUrl: true })),
        { label: page },
    ];
};

const IntegrationsBreadcrumbs: React.FC<Props> = props => {
    return <Breadcrumbs path={makeBreadrumbPath(props)} />;
};

export default memo(IntegrationsBreadcrumbs);
